<template>
  <div class="outmain ba_f">
    <div class="shuju_title mar_b20">
      <div class="shuju_title_text">
        <span>{{ $t('plugin.bond.title') }}</span>
      </div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('plugin.bond.list')" name="1"></el-tab-pane>
      <el-tab-pane :label="$t('plugin.bond.settingsTab')" name="2"></el-tab-pane>
    </el-tabs>
    <div class="flex mar_t20 mar_b20">
      <el-form :inline="true" :model="formInline" class="demo-form-inline searchform">
        <el-form-item :label="$t('rider.list.name')" class="mar_l20">
          <el-input v-model="formInline.userName" size="medium" :placeholder="$t('rider.list.namePh')" @input="onSearch"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.status')">
          <el-select v-model="formInline.state" :placeholder="$t('common.pleaseSelect')" @change="onSearch">
            <el-option v-for="item in bondStateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="userName" :label="$t('rider.list.name')" align="center"></el-table-column>
      <el-table-column prop="money" :label="$t('plugin.bond.amount')" align="center">
        <template slot-scope="scope">
          <span :class="{ 'color-green': ['1','4'].indexOf(scope.row.state) >= 0, 'color_r': ['2','3'].indexOf(scope.row.state) >= 0 }">{{ (scope.row.state == '1' ? '+' : '-') + scope.row.money }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" :label="$t('common.status')" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.state == '1'">{{ $t('plugin.bond.paid') }}</div>
          <div v-if="scope.row.state == '2'" class="color_r">{{ $t('plugin.bond.refundApplying') }}</div>
          <div v-if="scope.row.state == '3'" class="color_r">{{ $t('plugin.bond.refunded') }}</div>
          <div v-if="scope.row.state == '4'">{{ $t('plugin.bond.refundRejected') }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" :label="$t('plugin.bond.payTime')" align="center">
        <template slot-scope="scope">{{ scope.row.state == '3' ? '--' : scope.row.createdAt }}</template>
      </el-table-column>
      <el-table-column :label="$t('common.operation')" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.state == '2'">
            <el-button type="text" @click="handleOperate(scope.row,'adopt')">{{ $t('common.pass') }}</el-button>
            <el-button type="text" class="color_r" @click="handleOperate(scope.row,'reject')">{{ $t('common.reject') }}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="total" :page-size="size" :current-page.sync="formInline.page" @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>
<script>
import { bondList, bondOperation } from '@/api/plugins';
export default {
  data() {
    return {
      formInline: { page: 1, state: '', userName: '' },
      list: [],
      listLoading: false,
      activeName: '1',
      total: 0,
      size: 10,
    };
  },
  computed: {
    bondStateOptions() {
      return [
        { value: '', label: this.$t('common.all') },
        { value: '1', label: this.$t('plugin.bond.paid') },
        { value: '2', label: this.$t('plugin.bond.applyRefund') },
        { value: '3', label: this.$t('plugin.bond.refundedShort') },
        { value: '4', label: this.$t('plugin.bond.rejectRefund') },
      ];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    setSelectRows() {},
    handleClick() {
      if (this.activeName == '2') {
        this.$router.push({ name: 'bondSet' });
      }
    },
    handleOperate(row, type) {
      if (row.id) {
        const operateName = type == 'reject' ? this.$t('common.reject') : this.$t('common.pass');
        this.$baseConfirm(this.$t('confirm.actionNamed', { action: operateName }), null, async () => {
          const { msg } = await bondOperation({ id: row.id, type });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    onSearch() {
      this.fetchData();
    },
    fetchData() {
      bondList(this.formInline).then((res) => {
        if (res.code == 1) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
        }
      });
    },
    handleCurrentChange(val) {
      this.formInline.page = val;
      this.fetchData();
    },
  },
};
</script>
